import { HashtagLine, LockLine } from "@dropbox/dig-icons/assets";
import { useTranslation } from "react-i18next";
import { MetadataItem } from "./MetadataItem";

import type { Channel } from "@mirage/shared/search/search-result";

export type ChannelMetadataProps = {
  channel: Channel;
  isThreadedMessage: boolean;
};

export const ChannelMetadata = ({
  channel,
  isThreadedMessage,
}: ChannelMetadataProps) => {
  const { t } = useTranslation();
  const { name, type } = channel;

  const displayName = name.startsWith("# ")
    ? name.replace(/^#\s*/, "")
    : " " + name;

  const icon =
    type[".tag"] === "channel_type_private"
      ? LockLine
      : name.startsWith("# ")
        ? HashtagLine
        : undefined;

  const prefix = isThreadedMessage ? t("thread_in_channel_prefix") : undefined;

  return <MetadataItem prefix={prefix} title={displayName} iconSrc={icon} />;
};
